import React from 'react';
import { ShareLink as FrShareLink } from 'festo-react-ui-kit';
import useTranslation from '../../features/translation/hooks/useTranslation';
import { econdaClickEvent } from '../../Econda';
import './ShareLink.scss';
import { useLocation } from 'react-router';

enum TranslationKeys {
  SHARE = 'resultShare',
  COPY = 'resultCopy',
  COPIED = 'resultCopied',
}

const ShareLink: React.FC = () => {
  const t = useTranslation();
  const { pathname } = useLocation();

  function onClick() {
    econdaClickEvent(pathname, 'text link', 'share results', 'open');
  }
  function onClose() {
    econdaClickEvent(pathname, 'text link', 'share results', 'close');
  }
  function onOk() {
    econdaClickEvent(pathname, 'text link', 'share results', 'click');
  }

  return (
    <FrShareLink
      data-testid="share-link"
      copiedText={t(TranslationKeys.COPIED)}
      copyText={t(TranslationKeys.COPY)}
      shareText={t(TranslationKeys.SHARE)}
      onLinkClick={onClick}
      onOk={onOk}
      onClose={onClose}
    />
  );
};

export default ShareLink;
